module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_5.b2651716.png";